import * as Yup from "yup";

export const clientLeadsSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  phone: Yup.string().required("Phone is required"),
  email: Yup.string()
    .transform(value => (!value ? null : value))
    .nullable()
    .email("Invalid email"),
  company: Yup.string().nullable().notRequired(),
  service_name: Yup.string().nullable().notRequired(),
  requirements: Yup.string().nullable().notRequired(),
  status: Yup.string().nullable().notRequired(),
  priority_status: Yup.string().nullable().notRequired(),
  start_date: Yup.date()
    .nullable()
    .notRequired()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  end_date: Yup.date()
    .nullable()
    .notRequired()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  follow_up_date: Yup.date()
    .nullable()
    .notRequired()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  follow_up_time: Yup.string().nullable().notRequired(),
  summary: Yup.string().nullable().notRequired(),
});

